import LocalSettingsProtoDepricated from "../../../gd/settings/local-settings/local-settings-v3"

export default class LexicalEditorLocalSettings extends LocalSettingsProtoDepricated {

    public pinToolBar   : boolean = true
    public autolink     : boolean = true
    public showControls : boolean = true

    constructor(name?:string) {
        super(name ? name : "lexical-editor",{})

        this.normalize(this._readFromLocalStorage())
    }

    normalize(values:any) {
        this.pinToolBar     = _.get(values, 'pinToolBar', true)
        this.autolink       = _.get(values, 'autolink', true)
        this.showControls   = _.get(values, 'showControls', true)
    }

    toObject() {
        return {
            pinToolBar  : this.pinToolBar,
            autolink    : this.autolink,
            showControls: this.showControls,
        }
    }
}
